import { Prop, Vue } from 'vue-property-decorator';

export class AdmiralForm<MODEL extends object = {}, DTO extends object = {}> extends Vue {
  @Prop({ required: true, type: Object })
  readonly value!: MODEL;

  @Prop({ required: true, type: Object })
  readonly errors!: keyof MODEL;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onInput(key: keyof DTO, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  onErrorReset(key: keyof DTO) {
    this.$emit('resetError', key);
  }
}
